import { Col, Form, Input, Row, Divider, Breadcrumb } from 'antd';
import { MainLayout } from 'components';
import { Content } from 'antd/lib/layout/layout';
import { Link, useHistory } from 'react-router-dom';
import Button from 'components/Button';
import { AddFillIcon, XFillIcon } from 'assets/svg';
import { useEffect, useState } from 'react';
import { IBrand } from 'interface/brand.interface';
import pageTitleStore from 'store/pageTitleStore';

interface IProps {
  location: any;
}
export default function BrandDetailPage(props: IProps): JSX.Element {
  const { location } = props;
  const dataDrop = location.state;
  const pathSnippets = location.pathname.split('/').filter((i: any) => i);
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  useEffect(() => {
    setTitle(`${dataDrop?.grp_name}`);
    // setBreadcrumb([{ title: 'Bộ phận phát triển / ' + dataDrop?.grp_name }]);
    setBreadcrumb([
      { title: <a href="/brand">Bộ phận phát triển</a> },
      { title: <a href=""> {dataDrop?.grp_name} </a> },
    ]);
  }, []);

  return (
    <MainLayout isLoading={false}>
      <Content>
        <Form layout="vertical" className="items-center" autoComplete="off">
          <div>
            <p style={{ color: '#00538f', fontSize: '18px' }}>
              <strong>Bộ phận phát triển {dataDrop?.grp_name}</strong>
            </p>
          </div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={12}>
              {dataDrop?.list_user_drop?.map((item: any, index: number) => (
                // eslint-disable-next-line react/jsx-key
                <div style={{ marginTop: '10px', fontSize: '15px' }}>
                  <p>
                    Người quản lý
                    &nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;
                    {dataDrop?.list_user_drop[index].fullName +
                      ' - ' +
                      dataDrop?.list_user_drop[index].jobTitle +
                      ' - ' +
                      dataDrop?.list_user_drop[index].departmentName}
                  </p>
                </div>
              ))}
            </Col>
          </Row>

          <Divider dashed />
        </Form>
      </Content>
    </MainLayout>
  );
}
